import View from '../../../view.js';

namespace('IO.Views.Components.Rje', function (exports) {
  'use strict';

  var StateActionsAPI = IO.Views.Components.Rje.Api.StateActions,
    Codes = IO.Views.Components.Rje.Codes,
    StateActions = View.extend({
      dom: {
        START_LINK: '.start-link',
        STOP_LINK: '.stop-link',
        RESTART_LINK: '.restart-link',
        HALT_LINK: '.halt-link',
        LINK: '.start-link, .stop-link, .restart-link, .halt-link',
        LINKS: '.state-links',
        STATE: '.state-text',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.START_LINK] = '_start';
        events['click ' + this.dom.STOP_LINK] = '_stop';
        events['click ' + this.dom.RESTART_LINK] = '_restart';
        events['click ' + this.dom.HALT_LINK] = '_halt';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      initialize: function (options) {
        this.stateApi = new StateActionsAPI({
          csrf: options.csrf,
        });
        this.name = options.name;
        this.poll = options.poll;
        this._attachEvents();
      },

      destroy: function () {
        this.stopListening();
        this.off();
      },

      /*
        PRIVATE FUNCTIONS
      */
      _attachEvents: function () {
        this.listenTo(
          this.stateApi,
          'start:success',
          this._startSuccessCallback,
        );
        this.listenTo(this.stateApi, 'start:fail', this._startFailCallback);
        this.listenTo(this.stateApi, 'stop:success', this._stopSuccessCallback);
        this.listenTo(this.stateApi, 'stop:fail', this._stopFailCallback);
        this.listenTo(
          this.stateApi,
          'restart:success',
          this._restartSuccessCallback,
        );
        this.listenTo(this.stateApi, 'restart:fail', this._restartFailCallback);
        this.listenTo(this.stateApi, 'halt:success', this._haltSuccessCallback);
        this.listenTo(this.stateApi, 'halt:fail', this._haltFailCallback);

        this.listenTo(this.poll, 'virtuals', this._processVirtuals);
        this.listenTo(this.poll, 'error', this._setUnknown);
      },

      _processVirtuals: function (virtuals) {
        var virtual = virtuals[this.name];

        if (virtual) {
          this._setStatusState(virtual.state);
        } else {
          this._setUnknown();
        }
      },

      _alert: function (args) {
        if (this.alert) {
          this.alert.close();
        }
        this.alert = new Alert(args);
        this.alert.prependTo('#main-content').show();
      },

      _start: function (e) {
        var target = e.currentTarget,
          url = target.href;

        if ($(target).closest('.disabled').length) {
          return false;
        }

        this.$(this.dom.START_LINK).text('Starting...');
        this.$(this.dom.LINK).addClass('disabled');
        this.stateApi.start(url);
        return false;
      },

      _startSuccessCallback: function () {
        this._alert({
          message: 'Virtual node started',
          type: 'success',
        });
        this._setRunning();
      },

      _startFailCallback: function (response) {
        this._error(response.responseText);
        this.$(this.dom.START_LINK).text('Start');
        this.$(this.dom.LINK).removeClass('disabled');
      },

      _stop: function (e) {
        var target = e.currentTarget,
          url = target.href;

        if ($(target).hasClass('disabled').length) {
          return false;
        }

        this.$(this.dom.STOP_LINK).text('Shutting down...');
        this.$(this.dom.LINK).addClass('disabled');
        this.stateApi.stop(url);
        return false;
      },

      _stopSuccessCallback: function () {
        this._alert({
          message: 'Virtual node stopped',
          type: 'success',
        });
        this._setStopped();
      },

      _stopFailCallback: function (response) {
        this._error(response.responseText);
        this.$(this.dom.STOP_LINK).text('Shutdown');
        this.$(this.dom.LINK).removeClass('disabled');
      },

      _restart: function (e) {
        var target = e.currentTarget,
          url = target.href;

        if ($(target).hasClass('disabled').length) {
          return false;
        }

        this.$(this.dom.RESTART_LINK).text('Rebooting...');
        this.$(this.dom.LINK).addClass('disabled');
        this.stateApi.restart(url);
        return false;
      },

      _restartSuccessCallback: function () {
        this._alert({
          message: 'Virtual node restarted',
          type: 'success',
        });
        this._setRunning();
      },

      _restartFailCallback: function (response) {
        this._error(response.responseText);
        this.$(this.dom.RESTART_LINK).text('Reboot');
        this.$(this.dom.LINK).removeClass('disabled');
      },

      _halt: function (e) {
        var target = e.currentTarget,
          url = target.href;

        if ($(target).hasClass('disabled').length) {
          return false;
        }

        this.$(this.dom.HALT_LINK).text('Stoping...');
        this.$(this.dom.LINK).addClass('disabled');
        this.stateApi.halt(url);
        return false;
      },

      _haltSuccessCallback: function () {
        this._alert({
          message: 'Virtual node stopped',
          type: 'success',
        });
        this._setStopped();
      },

      _haltFailCallback: function (response) {
        this._error(response.responseText);
        this.$(this.dom.HALT_LINK).text('Stop');
        this.$(this.dom.LINK).removeClass('disabled');
      },

      _setStatusState: function (state) {
        switch (state) {
          case Codes.STATE_CRASHED:
          case Codes.STATE_STOPPED:
            this._setStopped();
            break;
          // TODO disable buttons
          // case Codes.STATE_SHUTTING_DOWN:
          //   this._[disable/hide]Options()
          //   break
          case Codes.STATE_RUNNING:
            this._setRunning();
            break;
          default:
            this._setUnknown();
            break;
        }
      },

      _setFlagStatus: function (status) {
        var capitalized =
          status.slice(0, 1).toUpperCase() + status.slice(1, status.length);

        this.$('.sensu-status')
          .removeClass(
            'sensu-status-online sensu-status-offline sensu-status-unknown',
          )
          .addClass('sensu-status-' + status)
          .prop('title', capitalized)
          .show();
      },

      _setStopped: function () {
        this.$(this.dom.LINKS).removeClass('invisible');
        this.$(this.dom.STOP_LINK).text('Shutdown').addClass('hide');
        this.$(this.dom.STOP_LINK).next().addClass('hide');
        this.$(this.dom.HALT_LINK).text('Stop').addClass('hide');
        this.$(this.dom.RESTART_LINK).addClass('hide');
        this.$(this.dom.RESTART_LINK).next().addClass('hide');
        this.$(this.dom.LINK).removeClass('disabled');
        this.$(this.dom.START_LINK).removeClass('hide');
        this.$(this.dom.START_LINK).next().addClass('hide');
        this.$(this.dom.STATE).text('Stopped');
        this._setFlagStatus('offline');
      },

      _setRunning: function () {
        this.$(this.dom.LINKS).removeClass('invisible');
        this.$(this.dom.START_LINK).text('Start').addClass('hide');
        this.$(this.dom.START_LINK).next().addClass('hide');
        this.$(this.dom.LINK).removeClass('disabled');
        this.$(this.dom.STOP_LINK).removeClass('hide');
        this.$(this.dom.STOP_LINK).next().removeClass('hide');
        this.$(this.dom.RESTART_LINK).text('Reboot').removeClass('hide');
        this.$(this.dom.RESTART_LINK).next().removeClass('hide');
        this.$(this.dom.HALT_LINK).text('Stop').removeClass('hide');
        this.$(this.dom.STATE).text('Running');
        this._setFlagStatus('online');
      },

      _setUnknown: function () {
        this.$(this.dom.STATE).text('Unknown');
        this.$(this.dom.LINKS).addClass('invisible');
        this._setFlagStatus('unknown');
      },

      _error: function (msg) {
        this._alert({
          message: msg || 'An error occurred. Please contact support.',
          type: 'alert',
        });
      },
    });

  exports.StateActions = StateActions;
});
